import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
const datePipe = new DatePipe('en-US');
/** swaps the date range string's pipe for dash
 * Also formats dates
 */
@Pipe({
  name: 'fieldDisplay',
  standalone: false
})
export class FieldDisplayPipe implements PipeTransform {
  transform(value: string, dataType: string) {
    return FieldDisplayPipe.GenerateDisplayValue(value, !!value, dataType);
  }

  public static GenerateDisplayValue(value: string, hasValue: boolean, dataType: string) {
    if (!hasValue) {
      return '';
    }
    if (dataType === 'Date') {
      return datePipe.transform(value, 'mediumDate');
    }
    if (dataType === 'DateRange') {
      return value.replace('|', '-');
    }
    return value;
  }
}
